import { LoanDefeasedPayments } from './LoanDefeasedPayments';

export default LoanDefeasedPayments;
